import FormInputWidget from "./FormInputWidget";

const FormPasswordWidget = props => (
  <FormInputWidget {...props} type="password" />
);

export default FormPasswordWidget;
